import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1 ?
        theme.typography.fontWeightRegular :
        theme.typography.fontWeightMedium,
  };
}

function Multiselect(props) {
  const theme = useTheme();
  const { label, options, selectedValue, selectedSetter, multiStatus } = props;


  const handleChange = (event) => {

    const {
      target: { value },
    } = event;

    if (multiStatus) {
      selectedSetter(
        // On autofill we get a stringified value.
        typeof value === "string" ? value.split(",") : value,
      );
    }
    else {
      selectedSetter(
        // On autofill we get a stringified value.
        value === selectedValue[0] ? [] : value.split(","),
        //typeof value === "string" ? value.split(",") : value,
      );
    }
  };

  return (
    <FormControl
      sx={{
        "width": 240,
        "bgcolor": "white",
        "borderRadius": 4,
        "height": 44,
        "mb": 2,
        "& .MuiInputBase-root": {
          width: 240,
          bgcolor: "white",
          border: 0,
          borderRadius: 4,
          height: 44,
        },
        "& .Mui-focused": {
          color: "gray !important",
        },
      }}
      className="Multiselect mr-4"
    >
      {label && <InputLabel
        sx={{
          mt: -0.75,
        }}
        id="demo-multiple-chip-label"
      >
        {label}
      </InputLabel>}
      <Select
        className="Multiselect-selectBox"
        multiple={multiStatus}
        value={selectedValue}
        onChange={handleChange}
        input={<OutlinedInput id="select-multiple-chip" label="Chip" notched={false} sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgb(209 213 219) !important",
            borderWidth: "1px !important",
          },
        }} />}
        renderValue={(selected) => (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              mt: 0.75,
              overflowY: "auto",
              overflowX: "hidden",
              height: 36,
            }}
        >
            {selected.map((value) => (
              <Chip key={value} label={value} />
            ))}
          </Box>
        )}
        MenuProps={MenuProps}
      >
        {options.map((name) => (
          <MenuItem
            key={name}
            value= {(options.length === 0) ? "" : name}
            style={getStyles(name, selectedValue, theme)}
          >
            {name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

Multiselect.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  selectedValue: PropTypes.arrayOf(PropTypes.string),
  selectedSetter: PropTypes.func,
  multiStatus: PropTypes.bool
};

Multiselect.defaultProps = {
  label: null,
  options: [],
  selectedValue: [],
  selectedSetter: () => { },
  multiStatus: true
};

export default Multiselect;
